<template>
  <layout>
    <div slot="content">
      <i-card title="产品分类">
        <div slot="content">
          <el-table :data="cateList" :border="true">
            <el-table-column prop="id" label="分类id"></el-table-column>
            <el-table-column prop="cate_name" label="分类名称"></el-table-column>
            <el-table-column prop="count" label="产品数量"></el-table-column>
            <el-table-column prop="sort" label="排序(数值越大越靠前)"></el-table-column>
            <el-table-column prop="is_index" label="是否首页展示">
              <template slot-scope="scope">
                <el-tag size="mini" v-if="scope.row.is_index == 1" type="success">是</el-tag>
                <el-tag size="mini" v-else type="danger">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="top_icon" label="是否顶部图标">
              <template slot-scope="scope">
                <el-tag size="mini" v-if="scope.row.top_icon == 1" type="success">是</el-tag>
                <el-tag size="mini" v-else type="danger">否</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <div slot-scope="scope">
                <router-link :to="{name:'settings.add_cate',query:{cate_id:scope.row.id}}">
                  <el-button size="mini" type="primary">编辑</el-button>
                </router-link>
                <el-button size="mini" type="danger" @click="delCate(scope.row.id)">删除</el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <router-link :to="{name:'settings.add_cate'}">
            <el-button type="success" size="medium" icon="el-icon-plus">添加分类</el-button>
          </router-link>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
  export default {
    name: "cate",
    data() {
      return {
        cateList: []
      }
    },
    methods: {
      getCateList: function () {
        this.$http.request('cateList').then(res => {
          this.cateList = res.data;
        });
      },
      delCate: function (cateId) {
        this.$confirm('是否删除该分类？删除后不恢复', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.request('delCate', {cate_id: cateId}).then((res) => {
            let _self = this;
            if (res.status === 'success') {
              this.$message({
                type: 'success',
                message: res.message,
                onClose: function () {
                  _self.getCateList();
                }
              });
            }
          });
        })
      }
    },
    created: function () {
      this.getCateList();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/cate.vue